import { render } from "./Slider.vue?vue&type=template&id=6297bf58&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=ts"
export * from "./Slider.vue?vue&type=script&lang=ts"

import "./Slider.vue?vue&type=style&index=0&id=6297bf58&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6297bf58"

export default script